


function refreshedCartDrawer(){
  fetch('/?sections=cart-drawer,cart-icon-bubble')
  .then(res => res.json())
  .then(data => {
    const parsedHTML = new DOMParser().parseFromString(data['cart-drawer'], 'text/html');
    const drawerInner = parsedHTML.querySelector('.drawer__inner');
    const isEmpty = drawerInner?.classList.contains('is-empty');
    console.log('isEmpty: ',isEmpty);
    const parsedState = {
      sections: {
        'cart-drawer': data['cart-drawer'],
        'cart-icon-bubble': data['cart-icon-bubble']
      },
      id: null
    };
    const cartDrawer = document.querySelector('cart-drawer');
    if(!isEmpty){
      cartDrawer.classList.remove('is-empty');
      cartDrawer.renderContents(parsedState);
    }
  });
  
}



class SwiperComponent extends HTMLElement {
  constructor() {
    super();
    this.swiperInstance = null;
    this.currentMode = null;
    this._resizeHandler = this.handleResize.bind(this);
  }

  connectedCallback() {
    this.initSlider();
    window.addEventListener("resize", this._resizeHandler);
  }

  disconnectedCallback() {
    window.removeEventListener("resize", this._resizeHandler);
    this.destroySlider();
  }

  handleResize() {
    const newMode = this.getMode();
    if (newMode !== this.currentMode) {
      this.destroySlider();
      this.initSlider();
    }
  }

  getMode() {
    return window.innerWidth >= 850 ? "desktop" : "tablet";
  }

  getConfig(mode) {
    // Get the config object from the data attribute we added in Liquid
    const configData = JSON.parse(this.getAttribute('data-swiper-config') || '{}');
    const isDesktop = mode === "desktop";

    return {
      slidesPerView: isDesktop ? configData.desktopSlides : configData.mobileSlides,
      spaceBetween: isDesktop ? configData.desktopSpacing : configData.mobileSpacing,
      autoplay: configData.autoplay ? { delay: 3000 } : false,
      navigation: {
        nextEl: this.closest('.slider-wrapper').querySelector(configData.navigation.nextEl),
        prevEl: this.closest('.slider-wrapper').querySelector(configData.navigation.prevEl),
      },
      pagination: {
        el: this.closest('.slider-wrapper').querySelector(configData.pagination.el),
        clickable: true,
        type: 'bullets' // Changed from progressbar to match your dots settings
      }
    };
  }

  initSlider() {
    const mode = this.getMode();
    this.currentMode = mode;
    
    // Check if slider should even run in this mode
    if (mode === "desktop" && !this.classList.contains("swiper--desktop")) return;
    if (mode !== "desktop" && !this.classList.contains("swiper--tablet")) return;

    const config = this.getConfig(mode);
    this.swiperInstance = new Swiper(this, config);
  }

  destroySlider() {
    if (this.swiperInstance) {
      this.swiperInstance.destroy(true, true);
      this.swiperInstance = null;
    }
  }
}

if (!customElements.get("swiper-component")) {
  customElements.define("swiper-component", SwiperComponent);
}